(() => {
  'use strict';
  let pending = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-native-buy-now]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending || button.disabled) return;
    const form = button.closest('form');
    const addButton = form?.querySelector('[name="add"]');
    if (!form || addButton?.disabled || addButton?.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;
    const errorNode = form.querySelector('[data-native-buy-now-error]');
    const chinese = document.documentElement.lang.startsWith('zh');
    const label = button.textContent;
    const data = new FormData(form);
    // FormData includes quantity and product properties associated via form="...".
    data.delete('return_to');
    data.delete('sections');
    data.delete('sections_url');
    if (!data.has('quantity')) data.set('quantity', '1');
    pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = chinese ? '正在进入结账…' : 'Proceeding to checkout…';
    if (errorNode) errorNode.hidden = true;
    let navigating = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json' }, body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description :
          (chinese ? '商品无法结账，请检查规格和数量。' : 'Unable to add this item. Please check the selection and quantity.'));
      }
      // Go directly to this store's Shopify checkout, without opening cart UI.
      window.location.assign(root + 'checkout');
      navigating = true;
    } catch (error) {
      if (errorNode) {
        errorNode.textContent = error.message || (chinese ? '请求失败，请重试。' : 'Unable to proceed. Please try again.');
        errorNode.hidden = false;
      }
    } finally {
      if (!navigating) {
        pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
      }
    }
  }, true);
  window.addEventListener('pageshow', () => {
    pending = false;
    document.querySelectorAll('[data-native-buy-now][aria-busy]').forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = document.documentElement.lang.startsWith('zh') ? '立即结账' : 'Buy Now';
    });
  });
})();

// Keep the new button's availability in step with the existing variant handler.
(() => {
  const observed = new WeakSet();
  function init() {
    document.querySelectorAll('[data-native-buy-now]').forEach(button => {
      if (observed.has(button)) return;
      const add = button.closest('form')?.querySelector('[name="add"]');
      if (!add) return;
      observed.add(button);
      const sync = () => {
        if (button.hasAttribute('aria-busy')) return;
        button.disabled = add.disabled || add.getAttribute('aria-disabled') === 'true';
      };
      new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
